import React, { ReactElement, useEffect, useState } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import GlobalErrors from '../../../module/GlobalErrors';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import LegislativnyMaterialUpdate
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialCreateUpdate/LegislativnyMaterialUpdate';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import { useUserContext } from '../../../context/UserContext';
import { canUpdateMaterial } from '../../../function/permissions';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import SuccessMessages from '../../../module/SuccessMessages';
import homeBreadcrumbButton
  from '../LegislativnyMaterialCreatePage/components/homeBreadcrumbButton';

const pouzivatelIsAdmin = (pouzivatel: CurrentUserDetail)
  : boolean => !!pouzivatel && pouzivatel?.roles?.includes(UserRoleEnum.SUPERADMIN);

const LegislativnyMaterialUpdatePage = (): ReactElement => {
  const { pathname } = useLocation();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail();
  const { pouzivatel } = useUserContext();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const [isBlocked, setIsBlocked] = useState<boolean>(false);

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  useEffect(() => {
    const messageHandler = (message: MessageEvent): void => {
      if (message.data?.type === 'blockNavigation') {
        setIsBlocked(message.data.value);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        isBlocked ? homeBreadcrumbButton
          : homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia() ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia() ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          to: pathname,
          heading: 'Úprava legislatívneho procesu',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={canUpdateMaterial(pouzivatel, materialDetail)}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  headingCaption={`Úprava legislatívneho procesu ${materialDetail?.cisloLegislativnehoMaterialu}`}
                  backLinkText={`Späť na ${materialDetail?.cisloLegislativnehoMaterialu}`}
                  backLinkRoute={routes.procesy.detail.withParams(type, year, index)}
                />
                <LegislativnyMaterialUpdate
                  legislativnyMaterialDetail={materialDetail}
                  isAdminWfe={pouzivatelIsAdmin(pouzivatel)}
                />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default LegislativnyMaterialUpdatePage;
